export const FETCH_QUERY_EVENTS = 'FETCH_QUERY_EVENTS';
export const FETCH_QUERY_EVENTS_FETCHING = 'FETCH_QUERY_EVENTS_FETCHING';
export const FETCH_QUERY_EVENTS_SUCCESS = 'FETCH_QUERY_EVENTS_SUCCESS';
export const FETCH_QUERY_EVENTS_FAIL = 'FETCH_QUERY_EVENTS_FAIL';
export const RESET_QUERY_EVENTS = 'RESET_QUERY_EVENTS';
export const UPDATE_QUERY_EVENTS = 'UPDATE_QUERY_EVENTS';
export const SET_EVENT = 'SET_EVENT';

export function fetchEvents(query, callback = () => {}) {
    return {
        type: FETCH_QUERY_EVENTS,
        query,
        callback
    };
}

export function resetQuery() {
    return {
        type: RESET_QUERY_EVENTS
    };
}

export function updateQueryEvents(events) {
    return {
        type: UPDATE_QUERY_EVENTS,
        events
    };
}

export function setEvent(event) {
    return {
        type: SET_EVENT,
        event
    };
}
